export const OPERATOR_CHAT_TOKEN = 'chat_operator_token'
